import React from 'react'
import {
  Box,
  Link,
  Space,
  TextBody,
  useMediaSize,
  muiBankTheme,
} from '@ally/metronome-ui'
import styled from 'styled-components'
import AccountGroup from '../../Shared/AccountGroup'
import AccountCard from '../../Shared/AccountCard'

const StyledBox = styled(Box)`
  border-top: 1px solid rgb(221, 221, 221);
`
const WealthBox = styled(Box)`
  ${({ theme: { space } }): string => `
    padding-left: ${space.xs};
    @media print {
      padding-left: 10px;
      break-inside: auto;
      border-top: 5px solid ${muiBankTheme.colors['slate-3']};
    `}
`
const WealthHeader = styled(TextBody)`
  text-transform: none;
  padding-left: 2px;
  line-height: 34px;
  @media print {
    border-bottom: 1px solid ${muiBankTheme.colors['slate-3']};
    background-color: ${muiBankTheme.colors['page-gray']};
    margin-left: -${muiBankTheme.space.xs};
    padding-left: ${muiBankTheme.space.xs};
  }
`
const StyledLink = styled(Link)`
  font-size: 18px;
`
const WealthProspect: React.FC = props => {
  const isMdDown = useMediaSize('MdDown')
  const isPrint = window.matchMedia('print').matches

  return (
    <AccountGroup name="wealth-prospect">
      <AccountCard type="INVW">
        {isMdDown && !isPrint ? (
          <StyledBox py="sm" px="sm">
            <TextBody tag="span" size="md">
              {/* fontSize 18px to match mobile table styling */}
              <StyledLink
                to="/ext-wealth/wealth-overview"
                text="Wealth Overview"
              />{' '}
              See how your investments are allocated, and build the view of your
              net worth by linking accounts at other institutions.
            </TextBody>
          </StyledBox>
        ) : (
          <WealthBox>
            {/* lineHeight is needed to match Table styling */}
            <WealthHeader tag="p" size="sm" weight="bold">
              Wealth Management
            </WealthHeader>
            {/* padding is needed to match Table styling */}
            <Space py="12px">
              <TextBody tag="p" size="sm">
                <Link to="/ext-wealth/wealth-overview" text="Wealth Overview" />{' '}
                See how your investments are allocated, and build the view of
                your net worth by linking accounts at other institutions.
              </TextBody>
            </Space>
          </WealthBox>
        )}
      </AccountCard>
    </AccountGroup>
  )
}

export default WealthProspect
